export default {
  'app.settings.menuMap.basic': 'Cài đặt cơ bản',
  'app.settings.menuMap.security': 'Cài đặt bảo mật',
  'app.settings.menuMap.binding': 'Liên kết tài khoản',
  'app.settings.menuMap.notification': 'Thông báo tin nhắn mới',
  'app.settings.basic.avatar': 'Ảnh đại diện',
  'app.settings.basic.change-avatar': 'Thay đổi ảnh đại diện',
  'app.settings.basic.email': 'Email',
  'app.settings.basic.email-message': 'Vui lòng nhập email của bạn!',
  'app.settings.basic.nickname': 'Tên hiển thị',
  'app.settings.basic.nickname-message': 'Vui lòng nhập tên hiển thị của bạn!',
  'app.settings.basic.profile': 'Hồ sơ cá nhân',
  'app.settings.basic.profile-message': 'Vui lòng nhập hồ sơ cá nhân của bạn!',
  'app.settings.basic.profile-placeholder': 'Giới thiệu ngắn về bản thân',
  'app.settings.basic.country': 'Quốc gia/Khu vực',
  'app.settings.basic.country-message': 'Vui lòng nhập quốc gia của bạn!',
  'app.settings.basic.geographic': 'Tỉnh thành',
  'app.settings.basic.geographic-message': 'Vui lòng nhập thông tin địa lý của bạn!',
  'app.settings.basic.address': 'Địa chỉ đường phố',
  'app.settings.basic.address-message': 'Vui lòng nhập địa chỉ của bạn!',
  'app.settings.basic.phone': 'Số điện thoại',
  'app.settings.basic.phone-message': 'Vui lòng nhập số điện thoại của bạn!',
  'app.settings.basic.update': 'Cập nhật thông tin',
  'app.settings.security.strong': 'Mạnh',
  'app.settings.security.medium': 'Trung bình',
  'app.settings.security.weak': 'Yếu',
  'app.settings.security.password': 'Mật khẩu tài khoản',
  'app.settings.security.password-description': 'Độ mạnh mật khẩu hiện tại',
  'app.settings.security.phone': 'Số điện thoại bảo mật',
  'app.settings.security.phone-description': 'Số điện thoại đã liên kết',
  'app.settings.security.question': 'Câu hỏi bảo mật',
  'app.settings.security.question-description':
    'Câu hỏi bảo mật chưa được thiết lập, chính sách bảo mật có thể bảo vệ hiệu quả tài khoản của bạn',
  'app.settings.security.email': 'Email dự phòng',
  'app.settings.security.email-description': 'Email đã liên kết',
  'app.settings.security.mfa': 'Thiết bị MFA',
  'app.settings.security.mfa-description':
    'Thiết bị MFA chưa liên kết, sau khi liên kết có thể xác nhận hai lần',
  'app.settings.security.modify': 'Chỉnh sửa',
  'app.settings.security.set': 'Thiết lập',
  'app.settings.security.bind': 'Liên kết',
  'app.settings.binding.taobao': 'Liên kết Taobao',
  'app.settings.binding.taobao-description': 'Hiện tại chưa liên kết tài khoản Taobao',
  'app.settings.binding.alipay': 'Liên kết Alipay',
  'app.settings.binding.alipay-description': 'Hiện tại chưa liên kết tài khoản Alipay',
  'app.settings.binding.dingding': 'Liên kết DingTalk',
  'app.settings.binding.dingding-description':
    'Hiện tại chưa liên kết tài khoản DingTalk',
  'app.settings.binding.bind': 'Liên kết',
  'app.settings.notification.password': 'Mật khẩu tài khoản',
  'app.settings.notification.password-description':
    'Tin nhắn từ người dùng khác sẽ được thông báo dưới dạng thư nội bộ',
  'app.settings.notification.messages': 'Tin nhắn hệ thống',
  'app.settings.notification.messages-description':
    'Tin nhắn hệ thống sẽ được thông báo dưới dạng thư nội bộ',
  'app.settings.notification.todo': 'Thông báo việc cần làm',
  'app.settings.notification.todo-description':
    'Danh sách việc cần làm sẽ được thông báo dưới dạng thư nội bộ',
  'app.settings.open': 'Mở',
  'app.settings.close': 'Đóng',
};
